// extracted by mini-css-extract-plugin
module.exports = {"HSContract":"index-module_HSContract_7cYLv"};